import CalendarIcon from '@mui/icons-material/CalendarMonth';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import {ListItemText, MenuItem, Stack, Typography} from '@mui/material';
import {object} from 'prop-types';
import React from 'react';

import QuotaDisplay from './QuotaDisplay.jsx';
import {getMinimumSQMCost} from './util.js';
import {formatProductTermRange} from '@app/util/format-dates';
import AreaIndicator from '@components/common/AreaIndicator.jsx';

const ProductOption = ({product, ...props}) => {
  const minCost = getMinimumSQMCost(product);

  return (
    <MenuItem {...props}>
      <ListItemText disableTypography>
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            marginBottom: 1,
            gap: 1,
          }}
        >
          <Typography sx={{textWrap: 'wrap'}}>{product.title}</Typography>
          <Typography variant="inherit" color="primary">
            <QuotaDisplay
              quota={product.quota_total - product.quota_used}
              isUnlimited={product.unlimited_quota}
            />
          </Typography>
        </Stack>
        <Stack
          direction={{sm: 'column', lg: 'row'}}
          sx={{gap: 1, color: 'text.secondary'}}
        >
          <Typography
            variant="body2"
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: 'text.secondary',
              gap: 0.5,
            }}
          >
            <CalendarIcon color="action" fontSize="small" />
            {`Access: ${formatProductTermRange(product)}`}
          </Typography>

          {minCost > 0 && (
            <>
              <Typography
                variant="body2"
                sx={theme => ({
                  color: 'inherit',
                  [theme.breakpoints.down('lg')]: {
                    display: 'none',
                  },
                })}
              >
                |
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: 'text.secondary',
                  gap: 0.5,
                }}
              >
                <PlaceOutlinedIcon color="action" fontSize="small" />
                Min quota: <AreaIndicator squareMeters={minCost} /> per feature
              </Typography>
            </>
          )}
        </Stack>
      </ListItemText>
    </MenuItem>
  );
};

ProductOption.propTypes = {
  product: object.isRequired,
};

export default ProductOption;
